<script>
import moveTextHover from '@/components/moveTextHover';

export default {
  name: 'standOutBtn',
  components: {
    moveTextHover
  },
  data() {
    return {
    };
  },
  props: {
    msg: {
      type: String,
      required: true,
    },
  },
  created() {
  },
  methods: {
    onClickEvent() {
      this.$emit('onClickEvent');
    }
  }
};
</script>

<template>
  <button class="stand-out-btn wf-dela-gothic-one-regular" :class="$mq" @click="onClickEvent">
    <span>
      <move-text-hover :target-text="msg" />
    </span>
  </button>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  // https://codepen.io/hexagoncircle/pen/MWMqXbK

  @property --gradient-angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }
  @property --gradient-angle-offset {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }
  @property --gradient-percent {
    syntax: "<percentage>";
    initial-value: 5%;
    inherits: false;
  }

  @property --gradient-shine {
    syntax: "<color>";
    initial-value: white;
    inherits: false;
  }

  @keyframes gradient-angle {
    to {
      --gradient-angle: 360deg;
    }
  }

  @keyframes shimmer {
    to {
      rotate: 360deg;
    }
  }

  .stand-out-btn {
    animation: gradient-angle linear infinite;
    animation-duration: 3s;

    position: relative;
    cursor: pointer;
    color: $textColor;
    font-size: 2em;
    padding: 10px 30px;

    border: 1px solid transparent;
    border-radius: 40px;
    overflow: hidden;

    isolation: isolate;
    // border部分の光
    background: linear-gradient($bgColor, black) padding-box,
      conic-gradient(
          from calc(var(--gradient-angle) - var(--gradient-angle-offset)),
          transparent,
          $accentColor2 var(--gradient-percent),
          var(--gradient-shine) calc(var(--gradient-percent) * 2),
          $accentColor2 calc(var(--gradient-percent) * 3),
          transparent calc(var(--gradient-percent) * 4)
        )
        border-box;
    box-shadow: inset 0 0 0 1px $bgColor;

    // 内部のグラデーション
    &::after {
      content: "";
      pointer-events: none;
      position: absolute;
      inset-inline-start: 50%;
      inset-block-start: 50%;
      translate: -50% -50%;
      z-index: -1;

      animation: shimmer linear infinite;
      animation-duration: 3s;

      width: 100%;
      aspect-ratio: 1;
      background: linear-gradient(
        -50deg,
        transparent,
        $accentColor2,
        transparent
      );
      mask-image: radial-gradient(circle at bottom, transparent 40%, black);
      opacity: 0.6;
    }


    // responsible -----------------------------------------------
    &.viewLg {
      font-size: 1.3em;
    }
    &.viewMd {
      font-size: 1.2em;
    }
    &.viewSm {
      font-size: 1.1em;
    }
  }
  
</style>
